export const INCENTIVE_NAME = {
  incitationPrincipale: 'incitationPrincipale',
  incitationOptionDeplacement: 'incitationOptionDeplacement',
  incitationOptionReponse: 'incitationOptionReponse',
  incitationPOI: 'incitationPOI'
}
